import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
import styles from './Textarea.module.scss';

const Textarea = ({
  disabled, placeholder, label, wrapperClass,
  className,
  error, value='', ...props
}) => {

  const inputRef = useRef(null)

  useEffect(() => {
    inputRef.current.style.height = 'inherit';
    inputRef.current.style.height = `${inputRef.current.scrollHeight}px`;
  }, [value])

  const classes = classNames(
    styles.textarea,
    { [styles.error]: error },
    className,
  );

  const wrapperClasses = classNames(
    styles.textareaWrapper,
    wrapperClass,
  );

  return (
    <div className={wrapperClasses} >
      <div className={styles.label}>{label}</div>
      <textarea
        ref={inputRef}
        className={classes}
        placeholder={placeholder}
        disabled={disabled}
        value={value}
        {...props}
      />
    </div>
  );
};
export default Textarea;
